import React from 'react';
import JiboEye from './JiboEye';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__brand">
          <JiboEye size={40} animated={false} />
          <span className="footer__title">jibo.net</span>
        </div>
        <p className="footer__tribute">
          A tribute to the world's first social robot and the people who loved him.
        </p>
        <p className="footer__quote">
          "Maybe someday... you can tell yours that I said hello."
        </p>
        <div className="footer__divider" />
        <p className="footer__disclaimer">
          This is an independent tribute site. Jibo is a trademark originally of Jibo, Inc.
          This site is not affiliated with Jibo, Inc., NTT, or MIT.
        </p>
        <p className="footer__copyright">
          &copy; {new Date().getFullYear()} jibo.net
        </p>
      </div>
    </footer>
  );
};

export default Footer;
